import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useForm, Controller } from "react-hook-form";
import { FaEdit } from "react-icons/fa";
import toast, { Toaster } from "react-hot-toast";
import { useParams } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { postAstro, updateAstro } from "../../Redux/Reducers/AstroReducer";
import { uploadImagecertifates, uploadMultipleImages } from "../../Redux/Actions/Action";
import { fetchExpertise } from "../../Redux/Reducers/ExpertisePro";
import { IoClose } from "react-icons/io5";
import { BsCloudUpload } from 'react-icons/bs';
import { IoIosClose } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { FaPen } from "react-icons/fa";

function AstrolgerAdd() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        watch,
        control,
    } = useForm();


    const [profileImg, setProfileImg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [languageData, setLanguagesData] = useState([]);
    const [skillData, setSkillData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedQualification, setSelectedQualification] = useState("");
    const [videoFile, setVideoFile] = useState([]);
    const [photoes, setPhotoes] = useState([]);
    const [panCardPreview, setPanCardPreview] = useState(null);
    const [gstPreview, setGstPreview] = useState(null);
    const [handleGallery, setHandleGallery] = useState([]);
    const [currentImage, setCurrentImage] = useState(null);
    const [aadharImages, setAadharImages] = useState([]);
    const [aadharPreviews, setAadharPreviews] = useState([]); // { id, name, type, localUrl, uploadedUrl }
    const [certificateFiles, setCertificateFiles] = useState([]);
    const [certificateMultiFiles, setCertificateMultiFiles] = useState([]);
    const [gstFile, setFiles] = useState([]);
    const [appointmentType, setAppointmentType] = useState(null);
    const [chequePreview, setChequePreview] = useState(null);
    const [status, setStatus] = useState("pending")
    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [tagOptions, settagOptions] = useState([]);
    const username = 'country'
    const ExpertiseData = useSelector((state) => state?.ExpertisePro?.expertiseData);

    // Helper functions for previewing different file types
    const isImageUrl = (url) => {
        if (!url) return false;
        return /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(url.split('?')[0]);
    };

    const isPdfUrl = (url) => {
        if (!url) return false;
        return /\.(pdf)$/i.test(url.split('?')[0]);
    };

    const isDocUrl = (url) => {
        if (!url) return false;
        return /\.(doc|docx|xls|xlsx|ppt|pptx|txt)$/i.test(url.split('?')[0]);
    };

    const isVideoUrl = (url) => {
        if (!url) return false;
        return /\.(mp4|webm|ogg|mov|m4v)$/i.test(url.split('?')[0]);
    };

    const getFileNameFromUrl = (url) => {
        try {
            const parts = url.split('/');
            return decodeURIComponent(parts[parts.length - 1].split('?')[0]);
        } catch (e) {
            return url;
        }
    };

    // Preview modal handlers
    const openPreview = (item) => {
        if (!item) return;
        const url = item.localUrl || item.url;
        if (!url) return;
        const name = item.name || getFileNameFromUrl(url);
        let type = item.type || '';
        if (!type) {
            if (isImageUrl(url)) type = 'image';
            else if (isPdfUrl(url)) type = 'pdf';
            else if (isVideoUrl(url)) type = 'video';
            else if (isDocUrl(url)) type = 'doc';
            else type = 'file';
        }
        setCurrentImage({ url, name, type });
        setIsOpen(true);
    };

    const handleDownload = () => {
        if (!currentImage || !currentImage.url) return;
        try {
            const link = document.createElement('a');
            link.href = currentImage.url;
            link.download = currentImage.name || getFileNameFromUrl(currentImage.url) || 'file';
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            console.error('Download failed', err);
            // fallback: open in new tab
            window.open(currentImage.url, '_blank');
        }
    };




    useEffect(() => {
        const fetchtags = async () => {
            try {
                const token = localStorage.getItem("vedhvidhi-admin-token");
                const response = await axios.get(`${process.env.REACT_APP_BASEURL}/admin/tag`, {
                    headers: {
                        Authorization: token,
                    },
                });
                const tags = response?.data?.data || [];

                const options = tags.map((tag) => ({
                    value: tag._id,
                    label: tag.tagName,
                }));
                settagOptions(options);
            } catch (err) {
                console.error("Failed to fetch astro tags", err);
            }
        };

        fetchtags();
    }, []);


    useEffect(() => {
        const fetchLanguages = async () => {
            try {
                const token = localStorage.getItem("vedhvidhi-admin-token");
                const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/language`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch languages");
                }

                const data = await response.json();
                setLanguagesData(data);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchLanguages();
    }, []);

    useEffect(() => {
        const fetchSkills = async () => {
            try {
                const token = localStorage.getItem("vedhvidhi-admin-token");
                const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/skill`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch languages");
                }

                const data = await response.json();

                setSkillData(data);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchSkills();
    }, []);

    useEffect(() => {
        dispatch(fetchExpertise());
    }, [dispatch]);


    const handleProfileImgChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            try {
                const formData = new FormData();
                formData.append("file", file);

                const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/imageUpload`, {
                    method: "POST",
                    body: formData,
                    headers: {
                        Authorization: `${process.env.REACT_APP_ADMIN_TOKEN}`,
                    },
                });

                if (!response.ok) throw new Error("Failed to upload image");

                const responseData = await response.json();
                const imageUrl = responseData?.data?.img;

                if (imageUrl) setProfileImg(imageUrl);
            } catch (error) {
                console.error("Error uploading image:", error);
                toast.error("Failed to upload profile image.");
            }
        }
    };

    const handleStatusSubmit = async (data) => {
        try {
            const token = localStorage.getItem("vedhvidhi-admin-token");

            const response = await axios.patch(
                `${process.env.REACT_APP_BASEURL}/admin/astroBankDetailVerify/${id}`,
                { status: status },
                {
                    headers: {
                        Authorization: token,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response?.status === 200) {

                if (response?.data?.success) {
                    setStatus(response.data.success);
                }
                handleClose();
                toast.success(
                    "The details have been submitted, please click on 'Save' at the end of the form, to update the details."
                );
            } else {
                toast.error("Failed to update status. Please try again.");
            }
        } catch (error) {
            toast.error("Failed to update status. Please try again.");
        }
    };

    const appointOptions = [
        { value: "online", label: "online consultaion" },
        { value: "physical", label: "Physical Visit" },
    ];

    const selectedType = watch("appointmentType");
    const days = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
    ];
    const [selectedForAllDays, setSelectedForAllDays] = useState(false);

    const [availability, setAvailability] = useState({
        monday: [{ startTime: "", endTime: "" }],
        tuesday: [{ startTime: "", endTime: "" }],
        wednesday: [{ startTime: "", endTime: "" }],
        thursday: [{ startTime: "", endTime: "" }],
        friday: [{ startTime: "", endTime: "" }],
        saturday: [{ startTime: "", endTime: "" }],
        sunday: [{ startTime: "", endTime: "" }],
        default: [{ startTime: "", endTime: "" }],
    });

    const handleCheckboxChange = (e) => {
        setSelectedForAllDays(e.target.checked);
    };

    const addTimeSlot = (day) => {
        const newSlot = { startTime: "", endTime: "" };

        if (selectedForAllDays) {
            if (availability.default.length < 2) {
                setAvailability((prev) => ({
                    ...prev,
                    default: [...prev.default, newSlot],
                }));
            }
        } else {
            if (availability[day].length < 2) {
                setAvailability((prev) => ({
                    ...prev,
                    [day]: [...prev[day], newSlot],
                }));
            }
        }
    };

    const handleTimeChange = (day, index, field, value) => {
        if (selectedForAllDays) {
            setAvailability((prev) => {
                const newDefault = [...prev.default];
                newDefault[index] = { ...newDefault[index], [field]: value };
                return { ...prev, default: newDefault };
            });
        } else {
            setAvailability((prev) => {
                const newDaySlots = [...prev[day]];
                newDaySlots[index] = { ...newDaySlots[index], [field]: value };
                return { ...prev, [day]: newDaySlots };
            });
        }
    };


    const removeTimeSlot = (day, index) => {
        if (selectedForAllDays) {
            setAvailability((prev) => {
                const newArr = [...prev.default];
                newArr.splice(index, 1);
                return { ...prev, default: newArr };
            });
        } else {
            setAvailability((prev) => {
                const newArr = [...prev[day]];
                newArr.splice(index, 1);
                return { ...prev, [day]: newArr };
            });
        }
    };

    const languageOptions = languageData?.data?.map((lang) => ({
        value: lang._id,
        label: lang.languageName,
    }));
    const skillOptions = Array.isArray(skillData?.data)
        ? skillData.data?.map((skill) => ({
            value: skill?._id,
            label: skill.skillName,
        }))
        : Array.isArray(skillData)
            ? skillData?.map((skill) => ({
                value: skill?._id,
                label: skill.skillName,
            }))
            : [];

    const ExpertiseDataOptions = ExpertiseData?.data?.map((exp) => ({
        value: exp._id,
        label: exp.expertiseName,
    }));

    const handleExpertiseChange = (selectedOptions) => {
        const selectedExpertise = selectedOptions?.map((option) => option?.value);
        setValue("expertise", selectedExpertise);
    };

    const handleLanguageChange = (selectedOptions) => {
        const selectedLanguages = selectedOptions?.map((option) => option?.value);
        setValue("languages", selectedLanguages);
    };

    const handleSkillChange = (selectedOptions) => {
        const selectedSkills = selectedOptions?.map((option) => option?.value);
        setValue("skills", selectedSkills);
    };



    const appointOption1 = [
        { value: "onlineConsultation", label: "Online Consultation" },
        { value: "physicalRate", label: "Physical Rate" },
    ];
    const [isOpen, setIsOpen] = useState(false);
    const closeModal = () => {
        setIsOpen(false);
        setCurrentImage("");
    };

    const handleImageAadharChange = async (e) => {
        const files = Array.from(e.target.files || []);
        if (files.length === 0) return;

        // create local previews immediately
        const newPreviews = files.map((file) => ({
            id: `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            name: file.name,
            type: file.type,
            localUrl: URL.createObjectURL(file),
            uploadedUrl: null,
        }));

        setAadharPreviews((prev) => [...prev, ...newPreviews]);

        try {
            const uploadedUrls = await dispatch(uploadMultipleImages(files));
            if (!uploadedUrls || uploadedUrls.length === 0) return;

            // append uploaded urls to form value and state
            setValue("aadharImg", uploadedUrls);
            setAadharImages((prevState) => [...prevState, ...uploadedUrls]);

            // map uploaded urls back to previews (by order)
            setAadharPreviews((prev) => {
                const merged = [...prev];
                let upIndex = merged.findIndex((p) => p.uploadedUrl === null);
                // fill uploadedUrl for the most recent previews in order
                for (let i = 0; i < uploadedUrls.length; i++) {
                    // find next preview without uploadedUrl
                    const idx = merged.findIndex((p) => p.uploadedUrl === null && newPreviews.some(np => np.localUrl === p.localUrl));
                    if (idx !== -1) {
                        merged[idx].uploadedUrl = uploadedUrls[i];
                    }
                }
                return merged;
            });
        } catch (error) {
            console.error("File upload failed:", error);
            toast.error('Failed to upload aadhar files');
        }
    };

    const removeAadharImage = (index) => {
        // kept for backward compatibility - remove preview at index if present
        setAadharPreviews((prev) => {
            const item = prev[index];
            if (item && item.localUrl) URL.revokeObjectURL(item.localUrl);
            const newArr = prev.filter((_, i) => i !== index);
            // also remove uploaded url if present
            if (item && item.uploadedUrl) {
                setAadharImages((prevImgs) => prevImgs.filter((u) => u !== item.uploadedUrl));
            }
            return newArr;
        });
        // if no preview exists at that index, just remove uploaded url at same index
        setAadharImages((prevState) => prevState.filter((_, i) => i !== index));
    };

    const removeAadharPreview = (index) => {
        setAadharPreviews((prev) => {
            const item = prev[index];
            if (item && item.localUrl) URL.revokeObjectURL(item.localUrl);
            const newArr = prev.filter((_, i) => i !== index);
            if (item && item.uploadedUrl) {
                setAadharImages((prevImgs) => prevImgs.filter((u) => u !== item.uploadedUrl));
            }
            return newArr;
        });
    };

    const removeAadharUploadedAt = (uploadedIndex) => {
        setAadharImages((prev) => prev.filter((_, i) => i !== uploadedIndex));
    };

    const handlePenCrdImg = async (e, fieldName) => {
        const file = e?.target?.files?.[0];
        if (!file) {
            setValue(fieldName, "");
            return;
        }

        // show immediate local preview
        const local = URL.createObjectURL(file);
        setPanCardPreview(local);

        try {
            const uploadedUrl = await dispatch(uploadImagecertifates(file));
            if (uploadedUrl) {
                setValue(fieldName, uploadedUrl);
                // replace local preview with uploaded URL (if needed)
                // revoke local preview
                try { URL.revokeObjectURL(local); } catch (e) { }
                setPanCardPreview(uploadedUrl);
            }
        } catch (error) {
            console.error("File upload failed:", error);
            toast.error('Failed to upload file');
        }
    };

    const removeGstImage = () => {
        setGstPreview(null);
    };

    const handleImageGstChange = async (e, fieldName) => {
        const file = e?.target?.files?.[0];
        if (!file) {
            console.error("No file selected.");
            return;
        }

        try {
            // immediate local preview
            const local = URL.createObjectURL(file);
            setGstPreview(local);

            const uploadedUrl = await dispatch(uploadImagecertifates(file));
            if (uploadedUrl) {
                setValue(fieldName, uploadedUrl);
                try { URL.revokeObjectURL(local); } catch (e) { }
                setGstPreview(uploadedUrl);
            }
        } catch (error) {
            console.error("File upload failed:", error);
            toast.error('Failed to upload file');
        }
    };

    const removeCertificateImage = (indexToRemove) => {
        setCertificateFiles(prev => prev.filter((_, i) => i !== indexToRemove));
    };

    const removePanCardImage = () => {
        setPanCardPreview(null);
        setValue("panCardImg", "");
    };

    const handleImageCertificateChange = async (e) => {
        const files = Array.from(e.target.files);
        const validFiles = files.filter((file) => file.type.startsWith("image/"));
        if (validFiles.length === 0) {

            return;
        }
        try {
            const uploadedUrls = await dispatch(uploadMultipleImages(validFiles));

            if (!uploadedUrls || uploadedUrls.length === 0) {
                console.error("No files uploaded successfully.");
                return;
            }

            setValue("certificates", uploadedUrls);
            setCertificateFiles((prevState) => [...prevState, ...uploadedUrls]);

            const payload = {
                certificates: uploadedUrls,
            };

        } catch (error) {
            console.error("File upload failed:", error);
        }
    };

    const removePhoto = (index) => {
        setPhotoes((prev) => prev.filter((_, i) => i !== index));
    };

    const removeVideo = (index) => {
        setVideoFile((prev) => prev.filter((_, i) => i !== index));
    };

    const removeGalleryImage = (index) => {
        setHandleGallery((prev) => prev.filter((_, i) => i !== index));
    };

    const handlePhotoChange = async (e) => {
        const files = Array.from(e.target.files);
        const validFiles = files.filter((file) => file.type.startsWith("image/"));
        if (validFiles.length === 0) {
            console.error("Please upload valid image files.");
            return;
        }
        try {
            const uploadedUrls = await dispatch(uploadMultipleImages(validFiles));

            if (!uploadedUrls || uploadedUrls.length === 0) {
                console.error("No files uploaded successfully.");
                return;
            }
            setValue("photoGallery", uploadedUrls);
            setPhotoes((prevState) => [
                ...(Array.isArray(prevState) ? prevState : []),
                ...uploadedUrls,
            ]);
            const payload = {
                certificates: uploadedUrls,
            };

        } catch (error) {
            console.error("File upload failed:", error);
        }
    };

    const handleVideoChange = async (e) => {
        const files = Array.from(e.target.files);
        const validFiles = files.filter((file) => file.type.startsWith("video/"));

        if (validFiles.length === 0) {
            console.error("Please upload valid video files.");
            return;
        }

        try {
            const uploadedUrls = await dispatch(uploadMultipleImages(validFiles));
            if (!uploadedUrls || uploadedUrls.length === 0) {
                console.error("No videos uploaded successfully.");
                return;
            }
            setValue("videos", uploadedUrls);
            setVideoFile((prevState) => [
                ...(Array.isArray(prevState) ? prevState : []),
                ...uploadedUrls,
            ]);

            const payload = {
                videos: uploadedUrls,
            };

        } catch (error) {
            console.error("Video upload failed:", error);
        }
    };

    const handleGalleryChange = async (e) => {
        const files = Array.from(e.target.files);
        const validFiles = files.filter((file) => file.type.startsWith("image/"));
        if (validFiles.length === 0) {
            console.error("Please upload valid image files.");
            return;
        }
        try {
            const uploadedUrls = await dispatch(uploadMultipleImages(validFiles));
            if (!uploadedUrls || uploadedUrls.length === 0) {
                console.error("No gallery photos uploaded successfully.");
                return;
            }
            setValue("photoGallery", uploadedUrls);
            setHandleGallery((prevState) => [
                ...(Array.isArray(prevState) ? prevState : []),
                ...uploadedUrls,
            ]);

            const payload = {
                gallery: uploadedUrls,
            };

        } catch (error) {
            console.error("Gallery photo upload failed:", error);
        }
    };


    const removeCertificateMultiFile = (indexToRemove) => {
        setCertificateMultiFiles(prev => prev.filter((_, i) => i !== indexToRemove));
    };

    const handleCertificateChange = async (e) => {
        const files = Array.from(e.target.files);
        const validFiles = files.filter((file) => file.type.startsWith("image/"));
        if (validFiles.length === 0) {
            console.error("Please upload valid image files.");
            return;
        }
        try {
            const uploadedUrls = await dispatch(uploadMultipleImages(validFiles));
            if (!uploadedUrls || uploadedUrls.length === 0) {
                console.error("No certificates uploaded successfully.");
                return;
            }

            setValue("certificateGallery", uploadedUrls);
            setCertificateMultiFiles((prevState) => [
                ...(Array.isArray(prevState) ? prevState : []),
                ...uploadedUrls,
            ]);
            const payload = {
                certificates: uploadedUrls,
            };

        } catch (error) {
            console.error("Certificate upload failed:", error);
        }
    };

    const convertTo24HourFormat = (timeStr) => {
        if (!timeStr) return "00:00";
        const [time, modifier] = timeStr.split(' ');
        let [hours, minutes] = time.split(':');
        hours = parseInt(hours);

        if (modifier === "PM" && hours !== 12) {
            hours += 12;
        }
        if (modifier === "AM" && hours === 12) {
            hours = 0;
        }
        if (hours === 0 && minutes === "00") {
            return "12:00 AM";
        }
        return `${hours < 10 ? '0' + hours : hours}:${minutes}`;
    };

    useEffect(() => {
        if (!id) return;

        const fetchAstrologer = async () => {
            try {
                const token = localStorage.getItem("vedhvidhi-admin-token");
                if (!token) {
                    toast.error("Token missing");
                    return;
                }

                const response = await axios.get(
                    `${process.env.REACT_APP_BASEURL}/admin/getAstro/${id}`,
                    {
                        headers: {
                            Authorization: token,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const astroData = response?.data?.data;
                if (!astroData) {
                    toast.error("Astrologer data not found");
                    return;
                }

                // =============== City, State, Country ================
                const astroCity = astroData?.city;
                const astroState = astroData?.state;

                const countryRes = await axios.get(
                    `https://secure.geonames.org/countryInfoJSON?username=${username}`
                );
                const countries = countryRes.data.geonames.map((item) => ({
                    ...item,
                    label: item.countryName,
                    value: item.geonameId,
                    countryCode: item.countryCode,
                }));
                setCountryOptions(countries);

                const india = countries.find((c) => c.label === "India");
                if (india) {
                    setSelectedCountry(india);

                    const stateRes = await axios.get(
                        `https://secure.geonames.org/childrenJSON?geonameId=${india.value}&username=${username}`
                    );
                    const stateData = stateRes.data.geonames.map((item) => ({
                        label: item.name,
                        value: item.name.toLowerCase(),
                        code: item.adminCode1,
                    }));
                    setStateOptions(stateData);

                    const matchedState = stateData.find(
                        (s) => s.value.toLowerCase() === astroState?.toLowerCase()
                    );
                    if (matchedState) {
                        setSelectedState(matchedState);

                        const cityRes = await axios.get(
                            `https://secure.geonames.org/searchJSON?adminCode1=${matchedState.code}&country=${india.countryCode}&featureClass=P&maxRows=1000&username=${username}`
                        );
                        const cityOptions = cityRes.data.geonames.map((item) => ({
                            label: item.name,
                            value: item.geonameId,
                        }));
                        setCityOptions(cityOptions);

                        const matchedCity = cityOptions.find(
                            (c) => c.label.toLowerCase() === astroCity?.toLowerCase()
                        );
                        if (matchedCity) {
                            setValue("city", matchedCity.label);
                        }
                    }
                }

                // =============== Availability =================
                const { _id, ...availability } = astroData?.availability || {};
                Object.keys(availability || {}).forEach((day) => {
                    availability[day] = availability[day].map((timeSlot) => ({
                        ...timeSlot,
                        startTime: convertTo24HourFormat(timeSlot.startTime),
                        endTime: convertTo24HourFormat(timeSlot.endTime),
                    }));
                });

                setValue("availability", availability);
                setAvailability(availability);

                const isAnyDayFilled = days.some(
                    (day) => Array.isArray(availability[day]) && availability[day].length > 0
                );
                setSelectedForAllDays(
                    astroData?.availability?.default?.length > 0 && !isAnyDayFilled
                );
                setValue(
                    "selectedForAllDays",
                    astroData?.availability?.default?.length > 0 && !isAnyDayFilled
                );

                // =============== Basic Form Fields =================
                setValue("fullName", astroData?.fullName || "");
                setValue("legalName", astroData?.legalName || "");
                setValue("email", astroData?.email || "");
                setValue("mobileNumber", astroData?.mobileNumber || "");
                setValue("pincode", astroData?.pincode || "");
                setValue("state", astroData?.state || "");
                setValue("address", astroData?.address || "");
                setValue("aadharNo", astroData?.aadharNo || "");
                setValue("profileBio", astroData?.profileBio || "");
                setValue("gstNo", astroData?.gstNo || "");
                setValue("panCardNo", astroData?.panCardNo || "");
                setValue("experience", astroData?.experience || "");
                setValue("specialization", astroData?.specialization || "");
                setProfileImg(astroData?.profileImg || "");
                setValue("profileImg", astroData?.profileImg || "");
                //================== Qualification =================
                const qualification = astroData?.qualification;
                if (["10+2", "Graduate", "Postgraduate"].includes(qualification)) {
                    setSelectedQualification(qualification);
                    setValue("qualification", qualification);
                } else if (qualification) {
                    setSelectedQualification("Other");
                    setValue("qualification", qualification);
                }

                // =============== Tags =================
                if (astroData?.tag?._id) {
                    setValue("tag", astroData.tag._id);
                }

                // =============== Languages & Expertise =================
                setValue("languages", astroData?.languages?.filter(l => l && l?._id).map((l) => l?._id) || []);
                setValue("skills", astroData?.skills.filter(l => l && l?._id).map((l) => l?._id) || []);
                setValue("expertise", astroData?.expertise?.filter(e => e && e._id).map((e) => e._id) || []);

                // =============== Media & Documents =================
                setValue("aadharImg", astroData?.aadharImg || "");
                setAadharImages(astroData?.aadharImg || "");

                setValue("panCardImg", astroData?.panCardImg || "");
                setPanCardPreview(astroData?.panCardImg || "");

                setValue("certificates", astroData?.certificates || []);
                setCertificateFiles(astroData?.certificates || []);

                setValue("photoGallery", astroData?.photoGallery || []);
                setHandleGallery(astroData?.photoGallery || []);

                setValue("photos", astroData?.photos || []);
                setPhotoes(astroData?.photos || []);

                setValue("videos", astroData?.videos || []);
                setVideoFile(astroData?.videos || []);

                setValue("certificateGallery", astroData?.certificateGallery || []);
                setCertificateMultiFiles(astroData?.certificateGallery || []);

                // =============== Bank Details =================
                const bank = astroData?.bankDetails || {};
                setValue("beneficiaryName", bank.beneficiaryName || "");
                setValue("bankName", bank.bankName || "");
                setValue("ifscCode", bank.ifscCode || "");
                setValue("accountNumber", bank.accountNumber || "");
                setValue("cancelledCheque", bank.cancelledCheque || "");
                setChequePreview(bank.cancelledCheque || "");
                setStatus(bank.verification || "pending");

                // =============== Billing =================
                const billing = astroData?.billingDetails || {};
                setValue("gstCertificate", billing.gstCertificate || "");
                setGstPreview(billing.gstCertificate || "");

                // =============== Charges =================
                setValue("commissionPercentage", astroData?.commissionPercentage || "");

                setValue("chat", {
                    ratePerMinute: astroData?.chat?.ratePerMinute || "",
                    offerPricePerMinute: astroData?.chat?.offerPricePerMinute || "",
                });

                setValue("call", {
                    ratePerMinute: astroData?.call?.ratePerMinute || "",
                    offerPricePerMinute: astroData?.call?.offerPricePerMinute || "",
                });

                setValue("videoCall", {
                    ratePerMinute: astroData?.videoCall?.ratePerMinute || "",
                    offerPricePerMinute: astroData?.videoCall?.offerPricePerMinute || "",
                });

                setValue("physicalVisit", {
                    ratePerMinute: astroData?.physicalVisit?.ratePerMinute || "",
                    offerPricePerMinute: astroData?.physicalVisit?.offerPricePerMinute || "",
                });

            } catch (error) {
                console.error("Error fetching astrologer:", error?.response || error);
                toast.error("Failed to fetch astrologer details");
            }
        };

        fetchAstrologer();
    }, [id, setValue]);


    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const onSubmit = async (data) => {
        handleClose();
        if (typeof data.panCardImg === "object" && Object.keys(data.panCardImg).length === 0) {
            data.panCardImg = "";
        }
        if (typeof data.gstCertificate === "object" && Object.keys(data.gstCertificate).length === 0) {
            data.gstCertificate = "";
        }
        const {
            selectedForAllDays,
            bankName,
            ifscCode,
            accountNumber,
            panCard,
            aadharCard,
            gstNumber,
            chat,
            call,
            videoCall,
            physicalVisit,
            cancelledCheque,
            beneficiaryName,
            tag,
            ...payloadData
        } = data;

        try {

            let formattedAvailability = selectedForAllDays
                ? { default: availability.default }
                : Object.fromEntries(Object.entries(availability).filter(([key]) => key !== "default"));


            let payload = {
                ...payloadData,
                profileImg,
                aadharImg: aadharImages,
                certificates: certificateFiles,
                photoGallery: handleGallery,
                photos: photoes,
                videos: videoFile,
                tag: tag,
                certificateGallery: certificateMultiFiles,
                availability: formattedAvailability,
                bankDetails: {
                    bankName: bankName || null,
                    beneficiaryName: beneficiaryName || null,
                    ifscCode: ifscCode || null,
                    accountNumber: accountNumber || null,
                    cancelledCheque: cancelledCheque || null,
                },
                billingDetails: {
                    panCard: panCard,
                    aadharCard: aadharCard,
                    gstNumber: gstNumber
                },
                chat: {
                    ratePerMinute: chat?.ratePerMinute,
                    offerPricePerMinute: chat?.offerPricePerMinute
                },
                call: {
                    ratePerMinute: call?.ratePerMinute,
                    offerPricePerMinute: call?.offerPricePerMinute
                },
                videoCall: {
                    ratePerMinute: videoCall?.ratePerMinute,
                    offerPricePerMinute: videoCall?.offerPricePerMinute,
                },
                physicalVisit: {
                    ratePerMinute: physicalVisit?.ratePerMinute,
                    offerPricePerMinute: physicalVisit?.offerPricePerMinute,
                }
            };


            if (id) {
                await dispatch(updateAstro({ id, payload })).unwrap();
                toast.success("Astrologer updated successfully!");
            } else {
                await dispatch(postAstro(payload)).unwrap();
                toast.success("Astrologer created successfully!");
            }


            navigate("/astrologer-list");
        } catch (error) {
            alert(`Failed to submit please check payload : ${error.message}`);
        }
    };

    useEffect(() => {
        axios
            .get(`https://secure.geonames.org/countryInfoJSON?username=${username}`)
            .then((response) => {
                const countries = response.data.geonames?.map((item) => ({
                    ...item,
                    label: item.countryName,
                    value: item.countryName,
                    countryCode: item.countryCode,
                    geonameId: item.geonameId,
                }));
                setCountryOptions(countries);

                // Default select India
                const india = countries.find((c) => c.label === "India");
                if (india) {
                    setSelectedCountry(india);
                    fetchStates(india.geonameId);
                }
            })
            .catch((error) => console.error("Error fetching countries:", error));
    }, []);

    const fetchStates = async (geonameId) => {
        try {
            const response = await axios.get(
                `https://secure.geonames.org/childrenJSON?geonameId=${geonameId}&username=${username}`
            );

            const options = response.data.geonames.map((item) => ({
                label: item.name,
                value: item.name,
                adminCode1: item.adminCode1,
            }));
            setStateOptions(options);
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };

    const fetchCities = async (adminCode1, countryCode) => {

        try {
            const response = await axios.get(
                `https://secure.geonames.org/searchJSON?adminCode1=${adminCode1}&country=${countryCode}&featureClass=P&maxRows=1000&username=${username}`
            );

            const options = response.data.geonames.map((item) => ({
                label: item.name,   // visible in dropdown
                value: item.name,   // send city name in payload
            }));

            setCityOptions(options);
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    };
    useEffect(() => {
        if (selectedCountry?.geonameId) {
            fetchStates(selectedCountry.geonameId);
        }
    }, [selectedCountry]);

    useEffect(() => {
        if (selectedState?.adminCode1 && selectedCountry?.countryCode) {
            fetchCities(selectedState.adminCode1, selectedCountry.countryCode);
        }
    }, [selectedState]);



    return (
        <>
            <button
                onClick={() => window.history.back()}
                style={{
                    marginBottom: "10px",
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                    fontFamily: "monospace",
                    fontSize: "18px",
                    color: "#007bff",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    padding: "10px 20px",
                }}
            >
                <span style={{ marginRight: "8px" }}>&lt;</span>
                <span style={{ position: "relative", display: "inline-block" }}>
                    Back
                    <span
                        style={{
                            content: "''",
                            position: "absolute",
                            left: 0,
                            bottom: -2,
                            width: "100%",
                            height: "1px",
                            borderBottom: "2px solid #007bff",
                        }}
                    ></span>
                </span>
            </button>

            <Toaster />
            <div>
                {/* Profile Image Upload UI */}
                <div className="col-sm-12">
                    <div className="file-upload">
                        <label htmlFor="profile-file-input">
                            <img
                                src={profileImg || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                                alt="Profile Icon"
                                className="icon"
                            />
                            <div className="edit-icon">
                                <FaPen />
                            </div>
                        </label>
                        <input
                            type="file"
                            id="profile-file-input"
                            onChange={handleProfileImgChange}
                            style={{ display: "none" }}
                        />
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="border-0 mb-4">
                        <div class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
                            <h3 class="fw-bold mb-0"></h3>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row g-4">
                        <div className="col-sm-6">
                            <label className="form-label">Full Name</label>
                            <input
                                {...register(
                                    "fullName",
                                    // { required: 'Full Name is required' }
                                )}
                                className={`form-control ${errors?.fullName ? "is-invalid" : ""}`}
                                placeholder="Your Name"
                            />
                            {errors.fullName && (
                                <p className="text-danger">{errors.fullName.message}</p>
                            )}
                        </div>
                        <div className="col-sm-6">
                            <label className="form-label">Legal Name (As per documents)</label>
                            <input
                                {...register(
                                    "legalName",
                                    // { required: 'Legal Name is required' }
                                )}
                                className={`form-control ${errors?.legalName ? "is-invalid" : ""}`}
                                placeholder="Your Legal Name"
                            />
                            {errors.legalName && (
                                <p className="text-danger">{errors.legalName.message}</p>
                            )}
                        </div>

                        <div className="col-sm-6">
                            <label className="form-label">Email Id</label>
                            <input
                                {...register(
                                    "email",
                                    // { required: 'email is required' }
                                )
                                }
                                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                placeholder="Enter Your Email"
                            />
                            {errors.email && (
                                <p className="text-danger">{errors.email.message}</p>
                            )}
                        </div>
                        <div className="col-sm-6">
                            <label className="form-label">Phone Number</label>
                            <input
                                {...register("mobileNumber", {
                                    required: 'Mobile number is required',
                                    pattern: {
                                        value: /^[0-9]{10}$/,
                                        message: "Mobile number must be 10 digits"
                                    }
                                })}
                                className={`form-control ${errors.mobileNumber ? "is-invalid" : ""}`}
                                placeholder="Enter Your Mobile Number"
                            />
                            {errors.mobileNumber && (
                                <p className="text-danger">{errors.mobileNumber.message}</p>
                            )}
                        </div>


                        <div className="col-sm-6">
                            <label className="form-label">Astro Tag</label>
                            <Controller
                                name="tag"
                                control={control}
                                // rules={{ required: "Astro Tag is required" }}
                                render={({ field }) => (
                                    <select
                                        {...field}
                                        className={`form-select ${errors.tag ? "is-invalid" : ""}`}
                                    >
                                        <option value="">Select Astro Tag</option>
                                        {tagOptions.map((tag) => (
                                            <option key={tag.value} value={tag.value}>
                                                {tag.label}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            />
                            {errors.tag && (
                                <div className="invalid-feedback">{errors.tag.message}</div>
                            )}
                        </div>




                        <div className="col-sm-6">
                            <label className="form-label">State</label>

                            <Controller
                                name="state"
                                control={control}
                                // rules={{ required: "State is required" }}
                                render={({ field }) => (
                                    <select
                                        {...field}
                                        className={`form-select ${errors.state ? "is-invalid" : ""}`}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            const selectedOption = stateOptions.find(opt => opt.value === selectedValue);
                                            field.onChange(selectedValue); // Update react-hook-form value
                                            setSelectedState(selectedOption || null); // Update local state
                                        }}
                                    >
                                        <option value="">Select State</option>
                                        {stateOptions.map((state) => (
                                            <option key={state.value} value={state.value}>
                                                {state.label}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            />
                            {errors.state && (
                                <div className="invalid-feedback">{errors.state.message}</div>
                            )}
                            {/* {errors.state && <p className="text-danger">{errors.state.message}</p>} */}
                        </div>


                        <div className="col-sm-6">
                            <label className="form-label">City</label>
                            <Controller
                                name="city"
                                control={control}
                                // rules={{ required: "City is required" }}
                                render={({ field }) => (
                                    <select
                                        {...field}
                                        className={`form-select ${errors.city ? "is-invalid" : ""}`}
                                    >
                                        <option value="">Select City</option>
                                        {cityOptions.map((city) => (
                                            <option key={city.value} value={city.label}>
                                                {city.label}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            />
                            {errors.city && <div className="invalid-feedback">{errors.city.message}</div>}
                        </div>




                        <div className="col-sm-4">
                            <label className="form-label">Aadhar No.</label>
                            <input
                                {...register(
                                    "aadharNo"
                                )}
                                className="form-control "
                                type="number"
                                placeholder="Enter Your Aadhar No."
                            />

                        </div>
                        <div className="col-sm-4">
                            <label className="form-label">Pan card No.</label>
                            <input
                                {...register(
                                    "panCardNo"

                                )}
                                className="form-control "
                                type="text"
                                placeholder="Enter Your Pan card No."
                            />

                        </div>

                        <div className="col-sm-12">
                            <label className="form-label">
                                Upload Aadhar Front & back photo
                            </label>
                            <div className="upload-container">
                                <label htmlFor="aadhar-upload" className="upload-label">
                                    Upload Aadhar photo
                                </label>
                                <label htmlFor="aadhar-upload">
                                    <span className="upload-icon">
                                        <BsCloudUpload />
                                    </span>
                                </label>
                                <input
                                    id="aadhar-upload"
                                    type="file"
                                    multiple
                                    onChange={handleImageAadharChange}
                                    style={{ display: "none" }}
                                />
                            </div>
                            {errors.aadharFile && (
                                <p className="text-danger">{errors.aadharFile.message}</p>
                            )}

                            <div className="uploaded-files mt-3 d-flex gap-2 flex-wrap">
                                {(() => {
                                    // build combined list: previews first, then uploaded-only files
                                    const previewItems = aadharPreviews.map(p => ({ localUrl: p.localUrl, url: p.uploadedUrl, name: p.name, type: p.type, isPreview: true, id: p.id }));
                                    const uploadedOnly = aadharImages.filter(u => !aadharPreviews.some(p => p.uploadedUrl === u)).map(u => ({ localUrl: null, url: u, name: getFileNameFromUrl(u), type: '', isPreview: false }));
                                    const combined = [...previewItems, ...uploadedOnly];

                                    return combined.map((item, idx) => (
                                        <div key={item.id || item.url || idx} className="position-relative d-inline-block text-center" style={{ width: 120 }}>
                                            <div onClick={() => openPreview(item)} style={{ cursor: 'pointer' }}>
                                                {item.localUrl ? (
                                                    // local preview available (before/while uploading)
                                                    (item.type && item.type.startsWith('image/')) || isImageUrl(item.localUrl) ? (
                                                        <img src={item.localUrl} alt={item.name || 'Preview'} width="100" height="100" className="rounded" />
                                                    ) : (item.type === 'application/pdf' || isPdfUrl(item.localUrl)) ? (
                                                        <object data={item.localUrl} type="application/pdf" width="100" height="100">
                                                            <a href={item.localUrl} target="_blank" rel="noreferrer">View PDF</a>
                                                        </object>
                                                    ) : (
                                                        <div style={{ width: 100, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #ddd', borderRadius: 8, padding: 8 }}>
                                                            <a href={item.localUrl} download={item.name} style={{ fontSize: 12, textDecoration: 'none' }}>{item.name}</a>
                                                        </div>
                                                    )
                                                ) : item.url ? (
                                                    isImageUrl(item.url) ? (
                                                        <img src={item.url} alt={item.name || 'File'} width="100" height="100" className="rounded" />
                                                    ) : isPdfUrl(item.url) ? (
                                                        <object data={item.url} type="application/pdf" width="100" height="100">
                                                            <a href={item.url} target="_blank" rel="noreferrer">View PDF</a>
                                                        </object>
                                                    ) : (
                                                        <div style={{ width: 100, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #ddd', borderRadius: 8, padding: 8 }}>
                                                            <a href={item.url} target="_blank" rel="noreferrer" style={{ fontSize: 12, textDecoration: 'none' }}>{item.name}</a>
                                                        </div>
                                                    )
                                                ) : null}
                                            </div>

                                            <button type="button" className="btn btn-sm btn-danger position-absolute top-0 end-0" style={{ borderRadius: "50%", padding: "0.2rem 0.5rem" }} onClick={(e) => { e.stopPropagation(); item.isPreview ? removeAadharPreview(aadharPreviews.findIndex(p => p.id === item.id)) : removeAadharUploadedAt(aadharImages.findIndex(u => u === item.url)); }}>
                                                <IoIosClose size={18} />
                                            </button>
                                        </div>
                                    ));
                                })()}
                            </div>

                        </div>
                        <div className="col-sm-12">
                            <label className="form-label">Upload Pan Card Photo</label>
                            <div className="upload-container">
                                <label htmlFor="pan-upload" className="upload-label">
                                    Upload Pan Card Photo
                                </label>
                                <label htmlFor="pan-upload">
                                    <span className="upload-icon">
                                        <BsCloudUpload />
                                    </span>
                                </label>
                                <input
                                    id="pan-upload"
                                    type="file"
                                    {...register("panCardImg")}
                                    onChange={(e) => handlePenCrdImg(e, "panCardImg")}
                                />
                            </div>
                            {panCardPreview && (
                                <div className="position-relative d-inline-block mt-2" style={{ width: 120 }}>
                                    <div onClick={() => openPreview({ url: panCardPreview, name: getFileNameFromUrl(panCardPreview), type: '' })} style={{ cursor: 'pointer' }}>
                                        {isImageUrl(panCardPreview) ? (
                                            <img src={panCardPreview} alt="Pan Card Preview" width="100" height="100" className="rounded" />
                                        ) : isPdfUrl(panCardPreview) ? (
                                            <object data={panCardPreview} type="application/pdf" width="100" height="100">
                                                <a href={panCardPreview} target="_blank" rel="noreferrer">View PDF</a>
                                            </object>
                                        ) : (
                                            <div style={{ width: 100, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #ddd', borderRadius: 8, padding: 8 }}>
                                                <a href={panCardPreview} target="_blank" rel="noreferrer" style={{ fontSize: 12, textDecoration: 'none' }}>{getFileNameFromUrl(panCardPreview)}</a>
                                            </div>
                                        )}
                                    </div>

                                    <button type="button" className="btn btn-sm btn-danger position-absolute top-0 end-0" style={{ borderRadius: "50%", padding: "0.2rem 0.5rem" }} onClick={(e) => { e.stopPropagation(); removePanCardImage(); }}>
                                        <IoIosClose size={18} />
                                    </button>
                                </div>
                            )}

                            {/* Preview Modal for clicked files */}
                            <Modal show={isOpen} onHide={closeModal} size="lg" centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>{currentImage?.name || 'Preview'}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{ textAlign: 'center' }}>
                                    {currentImage && (isImageUrl(currentImage.url) || currentImage.type === 'image') ? (
                                        <img src={currentImage.url} alt={currentImage.name} style={{ maxWidth: '100%', maxHeight: '70vh' }} />
                                    ) : currentImage && (isPdfUrl(currentImage.url) || currentImage.type === 'pdf') ? (
                                        <iframe src={currentImage.url} title={currentImage.name} style={{ width: '100%', height: '70vh', border: 0 }} />
                                    ) : currentImage && currentImage.type === 'video' ? (
                                        <video src={currentImage.url} controls style={{ maxWidth: '100%', maxHeight: '70vh' }} />
                                    ) : currentImage && currentImage.type === 'doc' ? (
                                        <iframe src={`https://docs.google.com/gview?url=${encodeURIComponent(currentImage.url)}&embedded=true`} title={currentImage.name} style={{ width: '100%', height: '70vh', border: 0 }} />
                                    ) : currentImage ? (
                                        <div style={{ padding: 20 }}>
                                            <p>{currentImage.name}</p>
                                            <a href={currentImage.url} target="_blank" rel="noreferrer">Open file in new tab</a>
                                        </div>
                                    ) : null}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={closeModal}>Close</Button>
                                    <Button variant="primary" onClick={handleDownload}>Download</Button>
                                </Modal.Footer>
                            </Modal>

                        </div>

                        <div className="col-sm-12">
                            <label className="form-label">Address</label>
                            <textarea
                                {...register(
                                    "address",

                                )}
                                className={`form-control`}
                                style={{ minHeight: "80px" }}
                                placeholder="Type Your Address"
                            />

                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="row align-items-center mt-4">
                    <div class="border-0 mb-4">
                        <div class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
                            <h3 class="fw-bold mb-0">Professional Information</h3>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row g-4">


                        <div className="col-sm-6">
                            <label className="form-label">Education Qualification</label>

                            <div className="position-relative">
                                <select
                                    {...register("qualification", {
                                        // required: "Education Qualification is required",
                                    })}
                                    className={`form-control ${errors.qualification ? "is-invalid" : ""}`}
                                    value={selectedQualification}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSelectedQualification(value);
                                        if (value !== "Other") {
                                            setValue("qualification", value);
                                        } else {
                                            setValue("qualification", "");
                                        }
                                    }}
                                >
                                    <option value="">Select Qualification</option>
                                    <option value="10+2">10+2</option>
                                    <option value="Graduate">Graduate</option>
                                    <option value="Postgraduate">Post Graduate</option>
                                    <option value="Other">Other</option>
                                </select>

                                {/* Arrow Icon (▼) */}
                                <span
                                    className="position-absolute"
                                    style={{
                                        top: '50%',
                                        right: '15px',
                                        transform: 'translateY(-50%)',
                                        pointerEvents: 'none',
                                        fontSize: '14px',
                                        color: '#6c757d',
                                    }}
                                >
                                    ▼
                                </span>
                            </div>

                            {errors.qualification && (
                                <p className="text-danger">{errors.qualification.message}</p>
                            )}
                        </div>


                        {selectedQualification === "Other" && (
                            <div className="col-sm-6 mt-2">
                                <label className="form-label">Other Qualification</label>
                                <input
                                    {...register("qualification", {
                                        // required: "Other Qualification is required",
                                    })}
                                    type="text"
                                    className={`form-control ${errors.qualification ? "is-invalid" : ""}`}
                                    placeholder="Enter other qualification"
                                />
                                {errors.qualification && (
                                    <p className="text-danger">{errors.qualification.message}</p>
                                )}
                            </div>
                        )}

                        <div className="col-sm-6">
                            <label className="form-label">Professional Expertise</label>
                            <Controller
                                name="expertise"
                                control={control}
                                // rules={{ required: "Please select at least one expertise." }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        isMulti
                                        options={ExpertiseDataOptions}
                                        value={ExpertiseDataOptions?.filter((option) =>
                                            field.value?.includes(option.value)
                                        )}
                                        onChange={(selectedOptions) =>
                                            field.onChange(selectedOptions.map(option => option.value))
                                        }
                                        placeholder="Select Expertise"
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    // isClearable={field.value?.length > 0}
                                    />
                                )}
                            />
                            {/* {errors.expertise && (
                                <p className="text-danger">{errors.expertise.message}</p>
                            )} */}
                        </div>
                        <div className="col-sm-6">
                            <div className="">
                                <label className="form-label">Languages</label>
                                <Controller
                                    name="languages"
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            isMulti
                                            options={languageOptions}
                                            value={languageOptions?.filter((option) =>
                                                field.value?.includes(option.value)
                                            )}

                                            onChange={handleLanguageChange}

                                            placeholder="Select Languages"
                                            className={`form-control ${errors.languageOptions ? "is-invalid" : ""
                                                }`}
                                            classNamePrefix="select"
                                            isClearable={field.value?.length > 0}
                                        />
                                    )}
                                />
                                {errors.languageOptions && (
                                    <p className="text-danger">{errors.languageOptions.message}</p>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="">
                                <label className="form-label">Skill</label>
                                <Controller
                                    name="skills"
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            isMulti
                                            options={skillOptions}
                                            value={skillOptions?.filter((option) =>
                                                field.value?.includes(option.value)
                                            )}

                                            onChange={handleSkillChange}

                                            placeholder="Select Skills"
                                            className={`form-control ${errors.skillOptions ? "is-invalid" : ""
                                                }`}
                                            classNamePrefix="select"
                                            isClearable={field.value?.length > 0}
                                        />
                                    )}
                                />
                                {errors.skillOptions && (
                                    <p className="text-danger">{errors.skillOptions.message}</p>
                                )}
                            </div>
                        </div>


                        <div className="col-sm-12">
                            <div className="d-flex justify-content-between align-items-center w-50 mb-4">
                                <label className="form-label">Availability Timing</label>
                                <div>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexCheckDefault"
                                        {...register("selectedForAllDays")}
                                        onChange={(e) => {
                                            setValue("selectedForAllDays", e.target.checked);
                                            setSelectedForAllDays(e.target.checked);
                                        }}
                                    />
                                    <label className="form-check-label ms-2" htmlFor="flexCheckDefault">
                                        Selected for all Days
                                    </label>
                                </div>

                            </div>

                            {selectedForAllDays ? (
                                <div className="default-availability mb-4">
                                    <h5>Default Availability (applies to all days)</h5>
                                    {availability?.default?.map((slot, index) => (
                                        <div key={index} className="row mb-3 align-items-end">
                                            <div className="col-sm-5">
                                                <label className="form-label">Start Time</label>
                                                <input
                                                    className="form-control"
                                                    type="time"
                                                    value={slot.startTime}
                                                    onChange={(e) => handleTimeChange("default", index, "startTime", e.target.value)}
                                                />
                                            </div>
                                            <div className="col-sm-5">
                                                <label className="form-label">End Time</label>
                                                <input
                                                    className="form-control"
                                                    type="time"
                                                    value={slot.endTime}
                                                    onChange={(e) => handleTimeChange("default", index, "endTime", e.target.value)}
                                                />
                                            </div>
                                            {availability.default.length > 1 && (
                                                <div className="col-sm-2">
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger"
                                                        onClick={() => removeTimeSlot("default", index)}
                                                    >
                                                        -
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => addTimeSlot("default")}
                                        disabled={availability.default.length >= 2}
                                    >
                                        +
                                    </button>
                                </div>
                            ) : (
                                // Individual day-based availability
                                days.map((day) => (
                                    <div key={day} className="day-availability mb-4">
                                        <div className="row mb-3 align-items-center">
                                            <div className="col-md-3">
                                                <label className="form-label">
                                                    {day.charAt(0).toUpperCase() + day.slice(1)}
                                                </label>
                                            </div>
                                            <div className="col-sm-8">
                                                {availability[day].map((slot, index) => (
                                                    <div key={index} className="row mb-2 align-items-end">
                                                        <div className="col-sm-5">
                                                            <input
                                                                className="form-control"
                                                                type="time"
                                                                value={slot.startTime}
                                                                onChange={(e) => handleTimeChange(day, index, "startTime", e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="col-sm-5">
                                                            <input
                                                                className="form-control"
                                                                type="time"
                                                                value={slot.endTime}
                                                                onChange={(e) => handleTimeChange(day, index, "endTime", e.target.value)}
                                                            />
                                                        </div>
                                                        {availability[day].length > 1 && (
                                                            <div className="col-sm-2">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger"
                                                                    onClick={() => removeTimeSlot(day, index)}
                                                                >
                                                                    -
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="col-md-1">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() => addTimeSlot(day)}
                                                    disabled={availability[day].length >= 2}
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>

                    </div>

                    {/* Professional Experience */}
                    <div className="col-sm-6">
                        <label className="form-label">
                            Professional Experience years
                        </label>
                        <input
                            {...register(
                                "experience",
                                // { required: 'Experience years is required' }
                            )}
                            className={`form-control ${errors.experience ? "is-invalid" : ""
                                }`}
                            type="text"
                            placeholder="Professional Experience years"
                        />
                        {errors.experience && (
                            <p className="text-danger">{errors.experience.message}</p>
                        )}
                    </div>

                    {/* GST No */}
                    <div className="col-sm-6">
                        <label className="form-label">GST No.</label>
                        <input
                            {...register(
                                "gstNo"
                                // ,
                                // { required: 'GST No. is required' }
                            )}
                            className={`form-control ${errors.gstNo ? "is-invalid" : ""}`}
                            type="text"
                            placeholder="Enter GST No"
                        />
                        {/* {errors.gstNo && (
                            <p className="text-danger">{errors.gstNo.message}</p>
                        )} */}
                    </div>

                    {/* Upload Certificate */}
                    <div className="col-sm-12">
                        <label className="form-label">Upload Certificate</label>
                        <div className="upload-container">
                            <label htmlFor="certificate-upload" className="upload-label">
                                Upload Certificates
                            </label>
                            <label htmlFor="certificate-upload">
                                <span className="upload-icon">
                                    <BsCloudUpload />
                                </span>
                            </label>
                            <input
                                id="certificate-upload"
                                type="file"
                                multiple
                                {...register("certificates",
                                    //      {
                                    //     validate: () => certificateFiles.length > 0 || "Please upload at least one certificate."
                                    // }
                                )}
                                onChange={handleImageCertificateChange}
                            />
                        </div>

                        {/* {errors.certificates && (
                            <p className="text-danger">{errors.certificates.message}</p>
                        )} */}

                        {/* <div className="uploaded-images">
                            {certificateFiles?.map((imageUrl, index) => (
                                <img
                                    key={index}
                                    src={imageUrl}
                                    alt="certificate"
                                    width="100"
                                    height="100"
                                />
                            ))}
                        </div> */}
                        <div className="uploaded-images d-flex gap-2 flex-wrap mt-2">
                            {certificateFiles.map((imageUrl, index) => (
                                <div key={index} className="position-relative d-inline-block">
                                    <div onClick={() => openPreview({ url: imageUrl, name: getFileNameFromUrl(imageUrl), type: '' })} style={{ cursor: 'pointer' }}>
                                        <img
                                            src={imageUrl}
                                            alt="certificate"
                                            width="100"
                                            height="100"
                                            className="rounded"
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-danger position-absolute top-0 end-0"
                                        style={{ borderRadius: "50%", padding: "0.2rem 0.5rem" }}
                                        onClick={(e) => { e.stopPropagation(); removeCertificateImage(index); }}
                                    >
                                        <IoIosClose size={18} />
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Upload GST Certificate */}
                    <div className="col-sm-12">
                        <label className="form-label">Upload GST Certificate</label>
                        <div className="upload-container">
                            <label htmlFor="gst-upload" className="upload-label">
                                Upload GST Certificate
                            </label>
                            <label htmlFor="file-upload-video">
                                <span className="upload-icon">
                                    <BsCloudUpload />
                                </span>
                            </label>
                            <input
                                id="gst-upload"
                                type="file"
                                {...register("gstCertificate"

                                    //  { required: 'gstCertificate is required' }
                                )

                                }
                                onChange={(e) => handleImageGstChange(e, "gstCertificate")}
                            />
                        </div>
                        {errors.gstCertificate && (
                            <p className="text-danger">{errors.gstCertificate.message}</p>
                        )}
                        {gstPreview && (
                            <div className="position-relative d-inline-block mt-2" style={{ width: 120 }}>
                                <div onClick={() => openPreview({ url: gstPreview, name: getFileNameFromUrl(gstPreview), type: '' })} style={{ cursor: 'pointer' }}>
                                    {isImageUrl(gstPreview) ? (
                                        <img src={gstPreview} alt="gstPreview" width="100" height="100" className="rounded" />
                                    ) : isPdfUrl(gstPreview) ? (
                                        <object data={gstPreview} type="application/pdf" width="100" height="100">
                                            <a href={gstPreview} target="_blank" rel="noreferrer">View PDF</a>
                                        </object>
                                    ) : (
                                        <div style={{ width: 100, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #ddd', borderRadius: 8, padding: 8 }}>
                                            <a href={gstPreview} target="_blank" rel="noreferrer" style={{ fontSize: 12, textDecoration: 'none' }}>{getFileNameFromUrl(gstPreview)}</a>
                                        </div>
                                    )}
                                </div>

                                <button type="button" className="btn btn-sm btn-danger position-absolute top-0 end-0" style={{ borderRadius: "50%", padding: "0.2rem 0.5rem" }} onClick={(e) => { e.stopPropagation(); removeGstImage(); }}>
                                    <IoIosClose size={18} />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="row align-items-center mt-4">
                <div className="border-0 mb-4">
                    <div className="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
                        <h3 className="fw-bold mb-0">Fees/Rate</h3>
                    </div>
                </div>
            </div>

            {/* Chat Section */}
            <div className="col-sm-12 mb-4">
                <label className="form-label">Chat</label>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-floating">
                            <input
                                {...register("chat.ratePerMinute", {
                                    // // required: "Per minute rate is required",
                                    // min: { value: 1, message: "Rate must be greater than 0" },
                                    // valueAsNumber: true,
                                })}
                                className={`form-control ${errors.chat?.ratePerMinute ? "is-invalid" : ""}`}
                                type="number"
                                placeholder="Actual Price"
                            />
                            <label>Actual Price</label>
                        </div>
                        {errors.chat?.ratePerMinute && (
                            <p className="text-danger">{errors.chat.ratePerMinute.message}</p>
                        )}
                    </div>
                    <div className="col-sm-6">
                        <div className="form-floating">
                            <input
                                {...register("chat.offerPricePerMinute", {
                                    // required: "Offer price is required",
                                    // min: { value: 1, message: "Offer Price must be greater than 0" },
                                    // valueAsNumber: true,
                                    // validate: (value) => {
                                    //     const actual = watch("chat.ratePerMinute");
                                    //     if (value > actual) return "Offer price cannot be greater than actual price";
                                    //     return true;
                                    // },
                                }
                                )}
                                className={`form-control ${errors.chat?.offerPricePerMinute ? "is-invalid" : ""}`}
                                type="number"
                                placeholder="Offer Price "
                            />
                            <label>Offer price</label>
                        </div>
                        {errors.chat?.offerPricePerMinute && (
                            <p className="text-danger">{errors.chat.offerPricePerMinute.message}</p>
                        )}
                    </div>
                </div>
            </div>


            {/* Call Section */}
            <div className="col-sm-12 mb-4">
                <label className="form-label">Call</label>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-floating">
                            <input
                                {...register("call.ratePerMinute",
                                    //      {
                                    //     required: "Actual price is required",
                                    //     min: { value: 1, message: "Price must be greater than 0" },
                                    //     valueAsNumber: true,
                                    // }
                                )}
                                className={`form-control ${errors.call?.ratePerMinute ? "is-invalid" : ""}`}
                                type="number"
                                placeholder="Actual Price"
                            />
                            <label>Actual Price</label>
                        </div>
                        {errors.call?.ratePerMinute && (
                            <p className="text-danger">{errors.call.ratePerMinute.message}</p>
                        )}
                    </div>
                    <div className="col-sm-6">
                        <div className="form-floating">
                            <input
                                {...register("call.offerPricePerMinute",
                                    //     {
                                    //     required: "Offer price is required",
                                    //     min: { value: 1, message: "Offer Price must be greater than 0" },
                                    //     valueAsNumber: true,
                                    //     validate: value => {
                                    //         const actualPrice = watch("call.ratePerMinute");
                                    //         if (value > actualPrice) return "Offer Price cannot be greater than actual price";
                                    //         return true;
                                    //     }
                                    // }
                                )}
                                className={`form-control ${errors.call?.offerPricePerMinute ? "is-invalid" : ""}`}
                                type="number"
                                placeholder="Offer Price"
                            />
                            <label>Offer Price</label>
                        </div>
                        {errors.call?.offerPricePerMinute && (
                            <p className="text-danger">{errors.call.offerPricePerMinute.message}</p>
                        )}
                    </div>
                </div>
            </div>

            {/* Repeat for Video Call */}
            <div className="col-sm-12 mb-4">
                <label className="form-label">Video Call</label>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-floating">
                            <input
                                {...register("videoCall.ratePerMinute",

                                )}
                                className={`form-control ${errors.videoCall?.ratePerMinute ? "is-invalid" : ""}`}
                                type="number"
                                placeholder="Actual Price"
                            />
                            <label>Actual Price</label>
                        </div>
                        {errors.videoCall?.ratePerMinute && (
                            <p className="text-danger">{errors.videoCall.ratePerMinute.message}</p>
                        )}
                    </div>
                    <div className="col-sm-6">
                        <div className="form-floating">
                            <input
                                {...register("videoCall.offerPricePerMinute",

                                )}
                                className={`form-control ${errors.videoCall?.offerPricePerMinute ? "is-invalid" : ""}`}
                                type="number"
                                placeholder="Offer Price"
                            />
                            <label>Offer Price</label>
                        </div>
                        {errors.videoCall?.offerPricePerMinute && (
                            <p className="text-danger">{errors.videoCall.offerPricePerMinute.message}</p>
                        )}
                    </div>
                </div>
            </div>

            {/* Repeat for Physical Visit */}
            <div className="col-sm-12 mb-4">
                <label className="form-label">Physical Visit</label>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-floating">
                            <input
                                {...register("physicalVisit.ratePerMinute",
                                    //     {
                                    //     required: "Actual price is required",
                                    //     min: { value: 1, message: "Price must be greater than 0" },
                                    //     valueAsNumber: true,
                                    // }
                                )}
                                className={`form-control ${errors.physicalVisit?.ratePerMinute ? "is-invalid" : ""}`}
                                type="number"
                                placeholder="Actual Price"
                            />
                            <label>Actual Price</label>
                        </div>
                        {errors.physicalVisit?.ratePerMinute && (
                            <p className="text-danger">{errors.physicalVisit.ratePerMinute.message}</p>
                        )}
                    </div>
                    <div className="col-sm-6">
                        <div className="form-floating">
                            <input
                                {...register("physicalVisit.offerPricePerMinute",
                                    //     {
                                    //     required: "Offer price is required",
                                    //     min: { value: 1, message: "Offer Price must be greater than 0" },
                                    //     valueAsNumber: true,
                                    //     validate: value => {
                                    //         const actualPrice = watch("physicalVisit.ratePerMinute");
                                    //         if (value > actualPrice) return "Offer price cannot be greater than actual price";
                                    //         return true;
                                    //     }
                                    // }
                                )}
                                className={`form-control ${errors.physicalVisit?.offerPricePerMinute ? "is-invalid" : ""}`}
                                type="number"
                                placeholder="Offer Price"
                            />
                            <label>Offer Price</label>
                        </div>
                        {errors.physicalVisit?.offerPricePerMinute && (
                            <p className="text-danger">{errors.physicalVisit.offerPricePerMinute.message}</p>
                        )}
                    </div>
                </div>
            </div>


            {/* Commission Section */}
            <div className="col-sm-6">
                <label className="form-label">Partner Remunration %</label>
                <input
                    {...register("commissionPercentage",
                        //     {
                        //     required: "Commission is required",
                        //     min: { value: 1, message: "Commission must be greater than 0" }
                        // }
                    )}
                    className={`form-control ${errors.commissionPercentage ? "is-invalid" : ""}`}
                    type="number"
                    placeholder="Partner Remunration %"
                />
                {errors.commissionPercentage && (
                    <p className="text-danger">{errors.commissionPercentage.message}</p>
                )}
            </div>


            <div>
                <div class="row align-items-center mt-4">
                    <div class="border-0 mb-4">
                        <div class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
                            <h3 class="fw-bold mb-0">Bank Details</h3>
                            {id && (
                                <FaEdit
                                    size={24}
                                    style={{ marginLeft: "10px", cursor: "pointer", color: "#007bff" }}
                                    onClick={handleShow}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div className="card-body">

                    <div className="row g-4">
                        <div className="col-sm-4">
                            <label className="form-label">Name of Bank</label>
                            <input
                                {...register(
                                    "bankName"
                                    // { required: 'Name of Bank is required' }
                                )}
                                className={`form-control ${errors.bankName ? "is-invalid" : ""
                                    }`}
                                type="text"
                                placeholder="Name of Bank"
                            />
                            {/* {errors.bankName && (
                                <p className="text-danger">{errors.bankName.message}</p>
                            )} */}
                        </div>
                    </div>

                    {/* IFSC Code */}
                    <div className="col-sm-4">
                        <label className="form-label">IFSC Code</label>
                        <input
                            {...register("ifscCode",
                                // {
                                //     required: 'IFSC code is required',
                                //     pattern: {
                                //         value: /^[A-Za-z]{4}\d{7}$/,
                                //         message: "Please enter a valid IFSC code",
                                //     },
                                // }
                            )}
                            className={`form-control ${errors.ifscCode ? "is-invalid" : ""}`}
                            type="text"
                            placeholder="IFSC Code"
                        />
                        {errors.ifscCode && (
                            <p className="text-danger">{errors.ifscCode.message}</p>
                        )}
                    </div>

                    {/* Account Number */}
                    <div className="col-sm-4">
                        <label className="form-label">Account Number</label>
                        <input
                            {...register("accountNumber"
                                , {
                                    // required: 'Account Number is required',
                                    // pattern: {
                                    //     value: /^[0-9]{10,18}$/,
                                    //     message: "Please enter a valid account number",
                                    // },
                                }
                            )}
                            className={`form-control ${errors.accountNumber ? "is-invalid" : ""
                                }`}
                            type="text"
                            placeholder="Account Number"
                        />
                        {errors.accountNumber && (
                            <p className="text-danger">{errors.accountNumber.message}</p>
                        )}
                    </div>
                </div>
                {/* Modal for editing bank details */}
                <Modal show={show} onHide={handleClose} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>View Bank Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSubmit(handleStatusSubmit)}>
                            <Form.Group className="mb-3">
                                <Form.Label>Beneficiary Name</Form.Label>
                                <Form.Control
                                    {...register("beneficiaryName",
                                        //  { required: "Name of Bank is required" }
                                    )
                                    }
                                    type="text"
                                />
                                {/* {errors.bankName && <p className="text-danger">{errors.bankName.message}</p>} */}
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Name of Bank</Form.Label>
                                <Form.Control
                                    {...register("bankName",
                                        //  { required: "Name of Bank is required" }
                                    )
                                    }
                                    type="text"
                                />
                                {/* {errors.bankName && <p className="text-danger">{errors.bankName.message}</p>} */}
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>IFSC Code</Form.Label>
                                <Form.Control
                                    {...register("ifscCode",
                                        // {
                                        // required: "IFSC Code is required",
                                        // pattern: {
                                        //     value: /^[A-Za-z]{4}\d{7}$/,
                                        //     message: "Please enter a valid IFSC code",
                                        // },
                                        // }
                                    )}
                                    type="text"
                                />
                                {/* {errors.ifscCode && <p className="text-danger">{errors.ifscCode.message}</p>} */}
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Account Number</Form.Label>
                                <Form.Control
                                    {...register("accountNumber",
                                        // {
                                        // required: "Account Number is required",
                                        // pattern: {
                                        //     value: /^[0-9]{10,18}$/,
                                        //     message: "Please enter a valid account number",
                                        // },
                                        // }
                                    )}
                                    type="text"
                                />
                                {/* {errors.accountNumber && <p className="text-danger">{errors.accountNumber.message}</p>} */}
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Preview Cancelled Cheque</Form.Label>
                                {chequePreview ? (
                                    <div>
                                        <img
                                            src={chequePreview}
                                            alt="Cancelled Cheque Preview"
                                            style={{ width: "100%", maxWidth: "300px", borderRadius: "5px" }}
                                        />
                                    </div>
                                ) : (
                                    <p>No cancelled cheque uploaded</p>
                                )}
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Status</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                >
                                    <option value="all">Select</option>
                                    <option value="approved">Success</option>
                                    <option value="rejected">Reject</option>
                                </Form.Control>
                            </Form.Group>
                            <Button variant="success" type="submit">Save Changes</Button>
                        </Form>
                    </Modal.Body>
                </Modal>
            </div>
            <div>
                <div class="row align-items-center mt-4">
                    <div class="border-0 mb-4">
                        <div class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
                            <h3 class="fw-bold mb-0">Billing Details</h3>
                        </div>
                    </div>
                </div>
                <div className="card-body">

                    <div className="row g-4">
                        <div className="col-sm-12">
                            <label className="form-label">PAN Card</label>
                            <input
                                {...register("panCard"
                                    //     , {
                                    //     required: 'PAN Card is required',
                                    //     pattern: {
                                    //         value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                                    //         message: "Please enter a valid PAN card number",
                                    //     },
                                    // }
                                )}
                                className={`form-control ${errors.panCard ? "is-invalid" : ""}`}
                                type="text"
                                placeholder="PAN Card"
                            />
                            {/* {errors.panCard && (
                                <p className="text-danger">{errors.panCard.message}</p>
                            )} */}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <label className="form-label">Aadhar Card</label>
                        <input
                            {...register("aadharCard"
                                // , {
                                // required: 'Aadhar Card is required',
                                // pattern: {
                                //     value: /^[2-9]{1}[0-9]{11}$/,
                                //     // message: "Please enter a valid Aadhar card number",
                                // },
                                // }
                            )}
                            className={`form-control ${errors.aadharCard ? "is-invalid" : ""
                                }`}
                            type="text"
                            placeholder="Aadhar Card"
                        />

                    </div>

                    <div className="col-sm-6">
                        <label className="form-label">GST Number (Optional)</label>
                        <input
                            {...register("gstNumber", {
                            })}
                            className={`form-control ${errors.gstNumber ? "is-invalid" : ""}`}
                            type="text"
                            placeholder="GST Number"
                        />

                    </div>
                </div>
            </div>
            <div>
                <div class="row align-items-center mt-4">
                    <div class="border-0 mb-4">
                        <div class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
                            <h3 class="fw-bold mb-0">About Me</h3>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    {isOpen && (
                        <>
                            <div className={`modalss ${isOpen ? "show" : ""}`}>
                                <div className={`modal-contentss ${isOpen ? "show" : ""}`}>
                                    <button className="close-btnss" onClick={closeModal}>
                                        ✖
                                    </button>
                                    <img src={currentImage} alt="Pop-up" />
                                </div>
                            </div>
                            <div
                                className={`modal-overlayss ${isOpen ? "show" : ""}`}
                                onClick={closeModal}
                            ></div>
                        </>
                    )}
                    {/* </form> */}

                    <div className="row g-4">
                        <div className="col-sm-12">
                            <label className="form-label">Profile Bio</label>
                            <textarea
                                style={{ minHeight: "80px" }}
                                className="form-control"
                                placeholder="Profile Bio..."
                                {...register("profileBio"
                                    // , { required: 'profileBio is required' }
                                )}
                            ></textarea>
                        </div>

                        <div className="col-sm-12">
                            <label className="form-label">Photos</label>
                            <div className="upload-container">
                                <label htmlFor="file-upload-photo" className="upload-label">
                                    Photo
                                </label>
                                <label htmlFor="file-upload-photo">
                                    <span className="upload-icon">
                                        <BsCloudUpload />
                                    </span>
                                </label>
                                <input
                                    id="file-upload-photo"
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handlePhotoChange(e)}
                                    multiple
                                />
                            </div>

                            <div className="review_imgCardMain uploaded-images mt-3">
                                {Array.isArray(photoes) && photoes.length > 0 ? (
                                    photoes?.map((imageUrl, index) => (
                                        <div
                                            key={index}
                                            className="position-relative d-inline-block me-2 mb-2"
                                        >
                                            <div onClick={() => openPreview({ url: imageUrl, name: getFileNameFromUrl(imageUrl), type: 'image' })} style={{ cursor: 'pointer' }}>
                                                <img
                                                    src={imageUrl}
                                                    alt="gallery"
                                                    width="100"
                                                    height="100"
                                                    className="rounded"
                                                />
                                            </div>
                                            <span
                                                className="btn btn-sm btn-danger position-absolute top-0 end-0"
                                                style={{ borderRadius: "50%", padding: "0.2rem 0.5rem" }}
                                                onClick={(e) => { e.stopPropagation(); removePhoto(index); }}
                                            >
                                                <IoClose />
                                            </span>
                                        </div>
                                    ))
                                ) : (
                                    <p>No gallery images uploaded.</p>
                                )}
                            </div>

                        </div>

                        <div className="col-sm-12">
                            <label className="form-label">Videos</label>
                            <div className="upload-container">
                                <label htmlFor="file-upload-video" className="upload-label">
                                    Videos
                                </label>
                                <label htmlFor="file-upload-video">
                                    <span className="upload-icon">
                                        <BsCloudUpload />
                                    </span>
                                </label>

                                <input
                                    id="file-upload-video"
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleVideoChange(e)}
                                    multiple
                                />
                            </div>

                            <div className="review_imgCardMain videropaly-play uploaded-images mt-3">

                                <ul>
                                    <li>


                                        <>
                                            <div className="videoclose">
                                                {Array.isArray(videoFile) && videoFile.length > 0 ? (
                                                    videoFile.map((videoUrl, index) => (
                                                        <video key={index} src={videoUrl} width="100" height="100" controls />
                                                    ))
                                                ) : (
                                                    <p></p>
                                                )}
                                                {/* <span><IoClose /></span> */}
                                                {videoFile.map((videoUrl, index) => (
                                                    <div key={index} className="position-relative d-inline-block me-2">
                                                        <div onClick={() => openPreview({ url: videoUrl, name: getFileNameFromUrl(videoUrl), type: 'video' })} style={{ cursor: 'pointer' }}>
                                                            <video src={videoUrl} width="100" height="100" controls />
                                                        </div>
                                                        <span
                                                            className="btn btn-sm btn-danger position-absolute top-0 end-0"
                                                            style={{ borderRadius: "50%", padding: "0.2rem 0.5rem" }}
                                                            onClick={(e) => { e.stopPropagation(); removeVideo(index); }}
                                                        >
                                                            <IoClose />
                                                        </span>
                                                    </div>
                                                ))}

                                            </div>


                                        </>

                                    </li>
                                </ul>

                            </div>
                        </div>

                        <div className="col-sm-12">
                            <label className="form-label">Gallery Photos</label>
                            <div className="upload-container">
                                <label htmlFor="file-upload-gallery" className="upload-label">
                                    Gallery Photos
                                </label>
                                <label htmlFor="file-upload-gallery">
                                    <span className="upload-icon">
                                        <BsCloudUpload />
                                    </span>
                                </label>

                                <input
                                    id="file-upload-gallery"
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleGalleryChange(e)}
                                    multiple
                                />
                            </div>
                            <div className="review_imgCardMain uploaded-images mt-3">
                                {Array.isArray(handleGallery) && handleGallery.length > 0 ? (
                                    handleGallery.map((imageUrl, index) => (
                                        <div key={index} className="position-relative d-inline-block me-2">
                                            <div onClick={() => openPreview({ url: imageUrl, name: getFileNameFromUrl(imageUrl), type: 'image' })} style={{ cursor: 'pointer' }}>
                                                <img src={imageUrl} alt="gallery" width="100" height="100" />
                                            </div>
                                            <span
                                                className="btn btn-sm btn-danger position-absolute top-0 end-0"
                                                style={{ borderRadius: "50%", padding: "0.2rem 0.5rem" }}
                                                onClick={(e) => { e.stopPropagation(); removeGalleryImage(index); }}
                                            >
                                                <IoClose />
                                            </span>
                                        </div>
                                    ))
                                ) : (
                                    <p>No gallery images uploaded.</p>
                                )}
                            </div>

                            {/* {handleGallery?.map((imageUrl, index) => (
                                <div key={index} className="position-relative d-inline-block me-2">
                                    <img src={imageUrl} alt="gallery" width="100" height="100" />
                                    <span
                                        className="btn btn-sm btn-danger position-absolute top-0 end-0"
                                        style={{ borderRadius: "50%", padding: "0.2rem 0.5rem" }}
                                        onClick={() => removeGalleryImage(index)}
                                    >
                                        <IoClose />
                                    </span>
                                </div>
                            ))} */}

                        </div>

                        <div className="col-sm-12">
                            <label className="form-label">Certificate Gallery</label>
                            <div className="upload-container">
                                <label
                                    htmlFor="file-upload-certificate"
                                    className="upload-label"
                                >
                                    Certificate Gallery
                                </label>
                                <label htmlFor="file-upload-certificate">
                                    <span className="upload-icon">
                                        <BsCloudUpload />
                                    </span>
                                </label>

                                <input
                                    id="file-upload-certificate"
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleCertificateChange(e)}
                                    multiple
                                />
                            </div>
                            <div className="review_imgCardMain uploaded-images mt-3">
                                {Array.isArray(certificateMultiFiles) && certificateMultiFiles.length > 0 ? (
                                    certificateMultiFiles.map((imageUrl, index) => (
                                        <div key={index} className="position-relative d-inline-block me-2">
                                            <div onClick={() => openPreview({ url: imageUrl, name: getFileNameFromUrl(imageUrl), type: 'image' })} style={{ cursor: 'pointer' }}>
                                                <img
                                                    src={imageUrl}
                                                    alt="certificate"
                                                    width="100"
                                                    height="100"
                                                    className="rounded"
                                                />
                                            </div>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-danger position-absolute top-0 end-0"
                                                style={{ borderRadius: "50%", padding: "0.2rem 0.5rem" }}
                                                onClick={(e) => { e.stopPropagation(); removeCertificateMultiFile(index); }}
                                            >
                                                <IoClose />
                                            </button>
                                        </div>
                                    ))
                                ) : (
                                    <p>No certificate images uploaded.</p>
                                )}
                            </div>

                        </div>

                        <div className="col-12 mt-4">
                            <button
                                type="submit"
                                className="btn btn-primary text-uppercase px-3"
                                disabled={isLoading}
                                onClick={handleSubmit(onSubmit)}
                            >
                                {isLoading ? "Saving..." : "Save"}
                            </button>
                            <Link
                                to="/astrologer-list"
                                className="btn btn-secondary text-uppercase px-3 mx-2"
                            >
                                Cancel
                            </Link>
                        </div>

                        {/* Modal */}
                        {isOpen && (
                            <>
                                <div className={`modalss ${isOpen ? "show" : ""}`}>
                                    <div className={`modal-contentss ${isOpen ? "show" : ""}`}>
                                        <button className="close-btnss" onClick={closeModal}>
                                            ✖
                                        </button>
                                        <img src={currentImage} alt="Pop-up" />
                                    </div>
                                </div>
                                <div
                                    className={`modal-overlayss ${isOpen ? "show" : ""}`}
                                    onClick={closeModal}
                                ></div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default AstrolgerAdd;
